<template>
  <Card>
    <CardHeader>
      <CardTitle>Your Referral Link</CardTitle>
    </CardHeader>
    <CardContent>
      <p class="text-sm text-gray-600 mb-4">
        Share this link on social media or with agents you'd like to bring onto the team. When someone applies through
        it, we'll credit you automatically.
      </p>
      <div v-if="props.referralLink" class="flex flex-col sm:flex-row gap-2">
        <div
          class="flex-1 min-w-0 rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-800 break-all"
        >
          {{ props.referralLink }}
        </div>
        <Button class="shrink-0" @click="copy">
          <Copy class="h-4 w-4 mr-2" />
          {{ copied ? 'Copied' : 'Copy link' }}
        </Button>
      </div>
      <p v-else class="text-sm text-gray-500">Your referral link will appear here once your account is fully set up.</p>
    </CardContent>
  </Card>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Copy } from 'lucide-vue-next';
import { toast } from 'vue-sonner';

const props = defineProps<{ referralLink: string | null }>();

const copied = ref(false);

const copy = async () => {
  if (!props.referralLink) return;
  try {
    await navigator.clipboard.writeText(props.referralLink);
    copied.value = true;
    toast.success('Link copied to clipboard');
    setTimeout(() => (copied.value = false), 2000);
  } catch {
    toast.error('Could not copy. Try selecting the link manually.');
  }
};
</script>
